module.exports = __webpack_public_path__ + "static/media/noConection.d1c2e462.svg";